import storejs from 'store';
import expirePlugin from 'store/plugins/expire';
import dayjs from 'dayjs';

storejs.addPlugin(expirePlugin);

const VUE_APP_H5_KEY = process.env.VUE_APP_H5_KEY;

function set(key, value, number, unit = 'day') {
  if (number) {
    const endTime = dayjs().add(number, unit).valueOf();
    return storejs.set(`${VUE_APP_H5_KEY}|${key}`, value, endTime);
  } else {
    return storejs.set(`${VUE_APP_H5_KEY}|${key}`, value);
  }
}

function get(key) {
  return storejs.get(`${VUE_APP_H5_KEY}|${key}`);
}

function remove(key) {
  return storejs.remove(`${VUE_APP_H5_KEY}|${key}`);
}

export default { set, get, remove };
